import React, { useEffect, useState } from 'react';
import axios from 'axios';
import AddTimesheetForm from './AddTimesheetForm';
import TimesheetList from './TimesheetList';

function TimesheetTab({ caseId }) {
  const [entries, setEntries] = useState([]);
  const [showForm, setShowForm] = useState(false);

  // Fetch timesheets for a specific case
  const fetchEntries = async () => {
    const token = localStorage.getItem("token");

    try {
      const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/timesheets/case/${caseId}`,{
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      });
      setEntries(res.data);
    } catch (err) {
      console.error('Error fetching timesheets:', err);
    }
  };

  // Run on mount or when caseId changes
  useEffect(() => {
    if (caseId) fetchEntries();
  }, [caseId]);

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this timesheet entry?")) {
      try {
        await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/api/timesheets/${id}`);
        fetchEntries();
      } catch (err) {
        console.error('Failed to delete timesheet entry:', err);
        alert('Error deleting entry');
      }
    }
  };

  const handleEdit = (entry) => {
    // Optional: implement edit navigation or modal
    alert('Edit functionality coming soon!');
  };

  return (
    <div className="space-y-4">
   

      <TimesheetList entries={entries}  />
    </div>
  );
}

export default TimesheetTab;
